export const NO_IMG_URL = 'https://static.wplus.ca/assets/noimage.png';
export const NEW_IMG_URL = 'https://static.wplus.ca/assets/new.png';
